// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"ApiActivation_pageContent__FI_zW"};